import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppBar, Box, BottomNavigation, BottomNavigationAction, Toolbar, Typography, IconButton, Menu, MenuItem, Avatar, Paper, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReceiptIcon from "@mui/icons-material/Receipt";
import HistoryIcon from "@mui/icons-material/History";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BarChartIcon from "@mui/icons-material/BarChart";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Tableau de bord", path: "/dashboard", icon: <DashboardIcon /> },
  { label: "Revenus", path: "/revenues", icon: <TrendingUpIcon /> },
  { label: "Dépenses", path: "/expenses", icon: <ReceiptIcon /> },
  { label: "Statistiques", path: "/statistics", icon: <BarChartIcon /> },
  { label: "Historique", path: "/history", icon: <HistoryIcon /> },
];

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const currentTab = NAV.findIndex(i => pathname.startsWith(i.path));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "primary.dark" }}>
      <AppBar position="fixed" elevation={0} sx={{ zIndex: theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <AccountBalanceWalletIcon sx={{ mr: 1, color: "primary.light" }} />
          <Typography variant="h6" fontWeight={700} sx={{ flexGrow: 1, color: "primary.light" }}>Budget App</Typography>
          <IconButton onClick={e => setAnchor(e.currentTarget)} color="inherit">
            <Avatar sx={{ width: 32, height: 32, bgcolor: "primary.dark", fontSize: 14 }}>{user?.name?.slice(0, 2)?.toUpperCase()}</Avatar>
          </IconButton>
          <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
            <MenuItem disabled><Typography variant="body2">{user?.name}</Typography></MenuItem>
            <MenuItem onClick={() => { logout(); nav("/login"); setAnchor(null); }}>Se déconnecter</MenuItem>
          </Menu>
        </Toolbar>
        {!isMobile && (
          <Tabs
            value={currentTab === -1 ? false : currentTab}
            onChange={(_, v) => nav(NAV[v].path)}
            textColor="primary"
            indicatorColor="primary"
            sx={{ px: 2, bgcolor: "rgba(0,0,0,0.2)" }}
          >
            {NAV.map(item => (
              <Tab key={item.path} label={item.label} icon={item.icon} iconPosition="start" />
            ))}
          </Tabs>
        )}
      </AppBar>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: isMobile ? "64px" : "112px",
          mb: isMobile ? "56px" : 0,
          bgcolor: "background.default",
          minHeight: isMobile ? "calc(100vh - 120px)" : "calc(100vh - 112px)",
        }}
      >
        {children}
      </Box>
      {isMobile && (
        <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000, bgcolor: "background.paper" }} elevation={3}>
          <BottomNavigation value={currentTab} onChange={(_, v) => nav(NAV[v].path)} sx={{ bgcolor: "background.paper" }}>
            {NAV.map(item => <BottomNavigationAction key={item.path} label={item.label} icon={item.icon} />)}
          </BottomNavigation>
        </Paper>
      )}
    </Box>
  );
}